type Props = {};
import bubbles from "./Subline_2x.png";

const SplashSubLine = ({}: Props) => {
    return (
        <div className="relative" style={{ width: "233px" }}>
            <div
                className="absolute text-white"
                style={{
                    fontWeight: "590",
                    lineHeight  : "125%",
                    letterSpacing: "-0.64px",
                    transform: "rotate(-2.394deg)",
                    top:"10.9px",
                    left:"19.8px"
                }}
            >
                Eine Zeitreise
            </div>
            <div
                className="absolute text-white"
                style={{
                    fontWeight: "590",
                    lineHeight  : "125%",
                    letterSpacing: "-0.64px",
                    transform: "rotate(1.514deg)",
                    top: "39px",
                    left: "77.8px"
                }}
            >
                durch Raum & Geld
            </div>
            <img src={bubbles} alt="subline" fetchPriority="high" />
        </div>
    );
};

export default SplashSubLine;